"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  textBox: {
    padding: theme.spacing(2)
  }
}));
const SingleImage = props => {
  const {
    title,
    text,
    media,
    reference,
    addition,
    option2
  } = props.data;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  const {
    filename,
    alt,
    height,
    width
  } = (0, _lodash.first)(media);
  const htmlTitle = title ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    component: "p",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }) : "";
  const htmlText = text ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1",
    component: "div",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }) : "";
  const textBox = htmlTitle || htmlText ? /*#__PURE__*/_react.default.createElement("div", {
    className: css.textBox
  }, htmlTitle, htmlText) : "";
  const image = /*#__PURE__*/_react.default.createElement(_image.default, {
    filename: filename && REACT_APP_PATH + filename,
    alt: alt,
    height: height,
    width: width
  });
  const wrap = (image, text) => {
    if (addition) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: addition,
        target: option2 === 1 ? "_blank" : "_self",
        rel: "noreferrer"
      }, image, text);
    } else if (reference && reference !== null && reference !== void 0 && reference.pageName) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: reference.pageName
      }, image, text);
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, image, text);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, wrap(image, textBox));
};
var _default = exports.default = SingleImage;